import { Subject } from 'rxjs';

const closePopupSubject$ = new Subject<void>();

export const PopupService = {
    closePopups: () => closePopupSubject$.next(),
    closePopupsObservable: () => closePopupSubject$.asObservable(),
};
